<template>
	<b-modal
		v-model="showModal"
		size="xl"
		centered
		hide-footer
		hide-header
		no-close-on-backdrop
		@shown="getAssets"
		@hidden="resetModal"
	>
		<main class="d-flex flex-column">
			<section class="flex-grow-1 border-down p-3">
				<div class="d-flex justify-content-between">
					<h1 class="black-txt">{{ modalTitle }}</h1>
					<img
						@click="$emit('close-modal'), (showFilter = false)"
						class="rotate-on-hover"
						src="@/assets/common/blue-cross.svg"
						alt=""
					/>
				</div>
			</section>
			<section class="p-3">
				<article class="pd-assets-main">
					<article
						class="d-flex justify-content-between align-items-center mt-2"
					>
						<div class="d-flex gap-2 align-items-center">
							<SearchBar
								ref="searchBar"
								@search-data="getAssets"
								:disabled="
									showloaderStatus ||
									(!showAssets.length && !searchFile) ||
									showSpinner
								"
							/>
							<div
								class="position-relative"
								v-closable="{
									exclude: ['ref1', 'ref2'],
									handler: 'closeFilter',
								}"
							>
							
								<div @click.stop="">
									
									 <div>
<PButton
										v-if="showAssets.length || filterApplied"
										type="filter"
										class="position-relative"
										text="Filter"
										ref="ref1"
										:disabled="
											showloaderStatus ||
											showSpinner
										"
										@clicked="(showFilter = !showFilter), openFilter()"
									/>
									<div class="red-indicator" v-if="filterApplied" ></div>
									 </div>
									
									<div class="position-absolute filter-assets">
										<div v-if="showFilter" class="dropdown-child">
											<div class="mt-2">
												<SingleSelect
													:isMandatory="false"
													:optionsArray="sortoptions"
													:text="'Sort by:'"
													@selectedOption="getSortValue"
													:selectedOptionProp="{
														text: selectedText,
														value: selectedVal,
													}"
												/>
											</div>
											<div class="mt-2" style="margin: 0 0 0 16px">
												<MultiSelectSearch
													:isMandatory="false"
													:items="tagOptions"
													:text="'Tags:'"
													@searched="getFilterTags"
													@selected="handleSelection"
													:selectedItems="tags"
													@shown="getFilterTags"
												/>
											</div>

											<footer
												class="d-flex align-items-center justify-content-between mt-4 ml-3 ms-3"
											>
												<div>
													<OButton
														text="Cancel"
														class="p1-15"
														@clicked="showFilter = !showFilter"
													/>
												</div>
												<div class="d-flex gap-2">
													<OButton
														@clicked="resetFilter"
														text="Reset"
														:disabled="!tags.length && !selectedVal"
														class="p1-15"
													/>
													<OButton
														text="Apply"
														@clicked="applyFilter"
														:disabled="!tags.length && !selectedVal"
														class="p1-15"
													/>
												</div>
											</footer>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="view-toggle mt-1" v-if="showAssets.length">
							<div v-if="gridView" class="d-flex gap-10 pointer">
								<img
									@click="gridView = true"
									src="@/assets/asset-bank/grid-view.svg"
								/>
								<img
									@click="gridView = false"
									src="@/assets/asset-bank/list-grid-view.svg"
								/>
							</div>
							<div v-else class="d-flex gap-10 pointer">
								<img
									@click="gridView = true"
									src="@/assets/asset-bank/grid-list-view.svg"
								/>
								<img
									@click="gridView = false"
									src="@/assets/asset-bank/list-view.svg"
								/>
							</div>
						</div>
					</article>
				</article>

				<template>
					<div class="ab-lv mt-3">
						<b-table-simple responsive class="mb-0" v-if="!gridView">
							<b-thead class="ab-lv-header">
								<b-tr>
									<b-th style="width: 40%" class="pl-4">File Name</b-th>
									<b-th style="width: 10%"
										><span class="d-flex align-items-center"> File Size </span>
									</b-th>
									<b-th style="width: 10%">
										<span class="d-flex align-items-center"
											>Uploaded Date
										</span>
									</b-th>
									<b-th style="width: 30%">Tags</b-th>
									<b-th style="width: 10%"></b-th>
								</b-tr>
							</b-thead>
						</b-table-simple>
					</div>
					<section
						:class="{
							'mt-3': gridView,
						}"
						class="overflow-auto"
						:style="
							!gridView
								? 'height: calc(100vh - 450px)'
								: 'height: calc(100vh - 404px)'
						"
						@scroll="onScroll"
					>
						<GridView
							v-if="gridView"
							@handle-get="getAssets"
							:assets="showAssets"
							@asset-selected="assetSelected"
							:showlazyLoading="showSpinner"
							:loaderStatus="showloaderStatus"
							:searchQuery="searchFile"
							:selectedAsset="selectedAsset"
						/>

						<ListView
							v-else
							@handle-get="getAssets"
							:assets="showAssets"
							@asset-selected="assetSelected"
							:showlazyLoading="showSpinner"
							:loaderStatus="showloaderStatus"
							:searchQuery="searchFile"
							:selectedAsset="selectedAsset"
						/>
					</section>
				</template>
			</section>

			<footer
				class="d-flex align-items-center justify-content-end pr-3 pb-3 mt-4 border-top pt-3"
			>
				<OButton
					@clicked="$emit('close-modal'), (showFilter = false)"
					text="Cancel"
					class="mr-3 pl-15"
					:disbaled="showLoader"
				/>

				<PButton
					:loading="showLoader"
					widthClass="button-width"
					:disabled="!selectedAsset"
					:text="modalTitle"
					@clicked="saveAsset"
					class="pl-15"
				/>
			</footer>
		</main>
	</b-modal>
</template>

<script>
// import { updateCourseAsset } from "../api-client/courseInfoAPI";
import {
	cloneAsset,
	getAsset,
	getTags,
} from "@/views/asset-bank/api-client/assets";
import GridView from "@/views/asset-bank/components/GridView.vue";
// import Shimmer from "@/views/asset-bank/components/AssetBankShimmer.vue";
import assetMixins from "@/views/asset-bank/mixins/assetMixins";
import ListView from "@/views/asset-bank/components/ListView.vue";
export default {
	name: "AddAssets",
	components: { GridView, ListView },
	mixins: [assetMixins],
	props: {
		showModal: {
			type: Boolean,
		},
		assetType: {
			type: String,
			default: "1",
		},
	},
	data() {
		return {
			headers: [
				{
					label: "File Name",
					style: "width: 40%",
				},
				{
					label: " File Size",
					style: "width: 10%",
				},
				{
					label: "Uploaded Date",
					style: "width: 10%",
				},
				{ label: "Tags", style: "width: 30%" },
				{ label: "", style: "width: 10%" },
			],
			isScroll: false,
			showSpinner: false,
			pageEnd: 0,
			showLoader: false,
			selectedText: "Select",
			selectedVal: "",
			filterApplied: false,
			searchFile: "",
			pageCounts: [
				{ text: "24", value: 24 },
				{ text: "50", value: 50 },
				{ text: "100", value: 100 },
				{ text: "125", value: 125 },
				{ text: "200", value: 200 },
			],
			sort_selected: "",
			gridView: true,
			showloaderStatus: false,
			sortOrder: "-1",
			sortBy: "updatedAt",
			showFilter: false,
			selectedAsset: null,
			inputPageNumber: 1,
			tagOptions: [],
			tags: [],
			selectedTags: [],
			page: 1,
			total: 0,
			showAssets: [],
			count: 24,
			showDpd: false,
			sortoptions: [
				{ text: "Name(Asce)", value: "1" },
				{ text: "Name(Desc)", value: "2" },
				{ text: "Date Created(Asce)", value: "3" },
				{ text: "Date Created(Desc)", value: "4" },
				{ text: "Date Modified(Asce)", value: "5" },
				{ text: "Date Modified(Desc)(Default)", value: "6" },
			],
		};
	},
	computed: {
		modalTitle() {
			switch (this.assetType) {
				case "3":
					return "Add Image";
				case "5":
					return "Add Note";
				case "6":
					return "Add Link";
				case "2":
					return "Add PPT";
				case "4":
					return "Add File";
				case "8":
					return "Add Zip";
				default:
					return "Add Video";
			}
		},
		currentResultsStart() {
			return (this.page - 1) * this.count + 1;
		},
		currentResultsEnd() {
			return Math.min(this.page * this.count, this.total);
		},
		maxPage() {
			return Math.ceil(this.total / this.count);
		},
	},
	watch: {
		showModal() {
			if (this.showModal) {
				this.showloaderStatus = true;
				this.showLoader = false;
			}
		},
		searchFile() {
			this.page = 1;
		},
	},
	methods: {
		onScroll(e) {
			if (this.showSpinner || this.showloaderStatus) return;
			const { target } = e;
			const triggerPoint = target.scrollHeight * 0.8;
			if (Math.ceil(target.scrollTop) >= triggerPoint - target.offsetHeight) {
				if (this.pageEnd >= 0 && this.pageEnd < this.total) {
					this.page++;
					this.showSpinner = true;
					this.getAssets();
				}
			}
		},
		openFilter() {
			if (this.filterApplied) {
				let val = {
					text: this.selectedText,
					value: this.selectedVal,
				};
				this.getSortValue(val);
				this.handleSelection(this.tags);
			} else {
				this.handleSelection([]);
				this.getSortValue({});
			}
		},
		closeFilter() {
			this.showFilter = false;
		},
		getSortValue(val) {
			switch (val.value) {
				case "1":
					this.sortBy = "title";
					this.sortOrder = "1";
					break;
				case "2":
					this.sortBy = "title";
					this.sortOrder = "-1";
					break;
				case "3":
					this.sortBy = "createdAt";
					this.sortOrder = "1";
					break;
				case "4":
					this.sortBy = "createdAt";
					this.sortOrder = "-1";
					break;
				case "5":
					this.sortBy = "updatedAt";
					this.sortOrder = "1";
					break;
				default:
					this.sortBy = "updatedAt";
					this.sortOrder = "-1";
			}
			this.selectedText = val.text ? val.text : "Select";
			this.selectedVal = val.value;
		},
		handleSelection(val) {
			this.tags = val;
		},
		async getFilterTags(searchFile = "") {
			let payload = {
				searchQuery: searchFile,
				page: 0,
				assetType: this.assetType,
			};
			const response = await getTags(payload);
			if (response.status === 200) {
				this.tagOptions = response.data.data.data;
			}
		},
		applyFilter() {
			this.filterApplied = true;
			this.showFilter = false;
			this.page = 1;

			if (this.$refs.searchBar) {
				this.$refs.searchBar.clear();
			}
			this.getAssets();
		},
		resetFilter() {
			this.tags = [];
			this.sortBy = "updatedAt";
			this.sortOrder = "-1";
			if (this.filterApplied) {
				if (this.$refs.searchBar) {
					this.$refs.searchBar.clear();
				}
				this.getAssets();
			}
			this.filterApplied = false;
			this.showFilter = false;
		},
		resetModal() {
			this.selectedAsset = null;
			this.inputPageNumber = 1;
			this.page = 1;
			this.total = 0;
			this.gridView = true;
			this.count = 24;
			this.showAssets = [];
		},
		assetSelected(asset) {
			this.selectedAsset = asset;
		},
		async saveAsset() {
			this.showLoader = true;
			if (["3", "1", "2", "4", "8"].includes(this.assetType)) {
				try {
					const response = await cloneAsset({
						assetID: this.selectedAsset.assetID,
					});
					if (response.status === 200) {
						this.$emit(
							"save-asset-" + this.modalTitle.split(" ")[1],
							response.data.data.assetInfo
						);
					}
				} catch (error) {
					console.log(error);
				}
			} else {
				this.$emit(
					"save-asset-" + this.modalTitle.split(" ")[1],
					this.selectedAsset
				);
			}
		},
		goToPage() {
			if (
				this.inputPageNumber >= 1 &&
				this.inputPageNumber <= Math.ceil(this.total / this.count)
			) {
				this.page = this.inputPageNumber;
				this.getAssets();
			}
		},
		closeDpd() {
			this.showDpd = false;
		},
		async getAssets(searchFile = "") {
			if (typeof searchFile !== "string") {
				searchFile = "";
			}
			try {
				if (!this.showSpinner) this.showloaderStatus = true;
				this.searchFile = searchFile;
				const payload = {
					searchQuery: this.searchFile,
					sortBy: this.sortBy,
					order: this.sortOrder,
					count: this.count,
					tags: this.tags || [],
					page: this.page - 1,
					type: 1,
					assetType: this.assetType,
				};
				if (this.searchFile) {
					payload.page = 0;
				}
				const response = await getAsset(payload);
				if (response.status === 200) {
					this.showloaderStatus = false;
					this.showFilter = false;
					if (payload.page == 0) {
						this.showAssets = response.data.data.data || [];
					} else {
						this.showAssets = [...this.showAssets, ...response.data.data.data];
					}
					this.total = response.data.data.total;
					this.pageEnd = response.data.data.pageEnd;
				}
			} catch (error) {
				console.log(error);
			} finally {
				this.$nextTick(() => {
					this.showSpinner = false;
				});
			}
		},
	},
};
</script>

<style>
.pd-assets-main {
	padding: 0rem 0.3125rem 0rem 1.25rem;
}

.height-fix-assets {
	height: calc(100vh - 450px);
	overflow-y: scroll;
}

.border-down {
	border-bottom: 0.0625rem solid #e4e7ec;
}

.files-txt {
	font-family: "Montserrat", sans-serif;
	font-size: 0.875rem;
	font-weight: 500;
	color: #72738e;
}
.filter-assets {
	position: absolute;
	top: -2px;
	right: -85px;
}
.view-toggle {
	background: #ffffff;
	border: 1px solid #e9f0f5;
	box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.25);
	border-radius: 30px;
	padding: 2px 6px;
}
.table th,
.table td {
	border-top: unset;
}
.table thead th {
	border-bottom: unset;
}
.ab-lv-bodytable table {
	border-collapse: separate;
	border-spacing: 0 var(--size-10);
}
.ab-lv .ab-lv-header {
	height: 45px;
	background: #e9f0f5;
	border-radius: var(--size-5);
	font-family: "Lato", sans-serif;
	font-weight: var(--weight-600);
	font-size: var(--size-14);
	color: #20639b;
	white-space: nowrap;
}
</style>
